import service from '@/plugins/service'
import { createFormData } from '@/plugins/formData'

const base = 'auth/'

export const isRequiredCaptcha = username => {
  return service({
    url: `${base}requiredCaptcha`,
    method: 'GET',
    params: {
      username
    }
  })
}

export const sendCaptcha = data => {
  return service({
    url: `${base}sendCaptcha`,
    method: 'POST',
    data: createFormData(data)
  })
}

export const login = data => {
  return service({
    url: `${base}login`,
    method: 'POST',
    data: createFormData(data)
  })
}

export const sendResetCaptcha = data => {
  return service({
    url: `${base}sendPasswdCaptcha`,
    method: 'POST',
    data: createFormData(data)
  })
}

export const updatePassword = data => {
  return service({
    url: `${base}user/updatePassword`,
    method: 'put',
    data
  })
}

export const resetPassword = id => {
  const data = createFormData({ id })
  return service({
    url: `${base}user/resetPassword`,
    method: 'put',
    data
  })
}

// 用户活跃度分析API
export const activeAnalyse = () => {
  return service({
    url: `${base}user/active/analyse`,
    method: 'GET'
  })
}

export const activeTrend = (params) => {
  return service({
    url: `${base}user/active/trend`,
    method: 'GET',
    params // 使用params传递查询参数
  })
}

export const activeRecent = (params) => {
  return service({
    url: `${base}user/active/recent`,
    method: 'GET',
    params // 使用params传递查询参数
  })
}

export const activeRecentInfo = (params) => {
  return service({
    url: `${base}user/active/recentInfo`,
    method: 'GET',
    params // 使用params传递查询参数
  })
}

// export const getRefreshToken = refreshToken => {
//   return service({
//     url: `${base}accessToken`,
//     method: 'GET',
//     params: {
//       refreshToken
//     }
//   })
// }
